import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PostUpdate from "../../components/PostUpdate";
import { backendUrl } from "../../constants";
import "./styles.css";

const MyPosts = ({ data }) => {
  const id = JSON.parse(localStorage.getItem("userData")).id;
  const [posts, setPosts] = useState([]);
  const [reload, setReload] = useState(false);
  //posts
  useEffect(() => {
    setPosts([])
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}user/listStatusUpdates/${id}/1/100`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            userId: obj.createdBy._id,
            value: obj._id,
            description: obj.status,
            date: obj.createdDate,
          };
          setPosts((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, [id, reload]);

  return (
    <div className="d-flex flex-column gap-2 px-5">
      <h5 className="text-dark text-center">Post Updates</h5>
      {posts.map((obj, ind) => (
        <PostUpdate data={obj} key={ind} setReload={setReload} />
      ))}
    </div>
  );
};
export default withTranslation()(MyPosts);
